<template>
  <div class="table-responsive">
    <table class="table table-stripped table-sm table-hover" v-if="ordered?.length">
      <thead>
        <tr>
          <th scope="col" class="bg-light" style="width: 25%">Oznaka - nalepka</th>
          <th scope="col" v-if="showType">Tip</th>
          <th scope="col" v-if="showService">Potrebne storitve</th>
          <th scope="col">Šifra</th>
          <th scope="col" v-if="showFacility">Objekt</th>
          <th scope="col" v-if="showSupplier">Dobavitelj</th>
          <th scope="col" v-if="showSelect">V delu</th>
          <th scope="col" v-if="editDates">Tesnost/1</th>
          <th scope="col" v-if="editDates">Servis/2</th>
          <th scope="col" v-if="editDates">Kondenzator/3,7</th>
          <th scope="col" v-if="editDates">CO2/4</th>
          <th scope="col" v-if="editDates">Termometer/5</th>
          <th scope="col" v-if="editDates">Sistem/6</th>
          <th scope="col" v-if="showSelect"></th>
        </tr>
      </thead>
      <tbody>
        <tr role="button" v-for="w in ordered">
          <td @click="selectDevice(w.id, true)" class="bg-light">
            <span v-if="w._isChild" style="margin-left: 1.5rem; color: #6c757d">↳ </span>{{ w.label }}
          </td>
          <td @click="selectDevice(w.id)" v-if="showType">{{ deviceTypes.get(w.typeText) }}</td>
          <td v-if="showService">
            <div v-if="showSelect">
              <div
                class="form-check"
                v-show="w.hasLeakageTest && (w.isLeakageTestOverdue || w.isLeakageTest || isLeakageCheck || !isXCheck)"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isLeakageTestOverduec"
                  v-model="w.isLeakageTest"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isLeakageTestOverduec">
                  <span class="badge rounded-pill bg-success">Tesnost</span>
                </label>
                &nbsp;
                <span class="badge rounded-pill bg-warning" v-show="w.isLeakageTestOverdue">
                  {{ w.lastLeakageTest === "0001-01-01" ? "Preveri pri vodji" : w.lastLeakageTest }}
                </span>
              </div>
              <div
                class="form-check"
                v-show="w.hasService && (w.isServiceOverdue || w.isService || isService || !isXCheck)"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isServiceOverduec"
                  v-model="w.isService"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isServiceOverduec">
                  <span class="badge rounded-pill bg-primary">Servis</span>
                </label>
                <span class="badge rounded-pill bg-warning" v-show="w.isServiceOverdue">
                  {{ w.lastService === "0001-01-01" ? "Preveri pri vodji" : w.lastService }}
                </span>
              </div>

              <div
                class="form-check"
                v-show="
                  w.hasCondenserCleaningWet &&
                  (w.isCondenserCleaningOverdue || w.isCondenserCleaning || isCondenserCleaning || !isXCheck)
                "
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isCondenserCleaningOverduec"
                  v-model="w.isCondenserCleaning"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isCondenserCleaningOverduec">
                  <span class="badge rounded-pill bg-light text-dark">Kondenzator mokro</span>
                </label>
                &nbsp;
                <span
                  class="badge rounded-pill"
                  :class="{
                    'bg-warning': w.isCondenserCleaningDryOverdue,
                    'bg-success': !w.isCondenserCleaningDryOverdue,
                  }"
                >
                  {{ w.lastCondenserCleaning === "0001-01-01" ? "Preveri pri vodji" : w.lastCondenserCleaning }}
                </span>
              </div>

              <div
                class="form-check"
                v-show="
                  w.hasCondenserCleaningDry &&
                  (w.isCondenserCleaningDryOverdue || w.isCondenserCleaningDry || isCondenserCleaningDry || !isXCheck)
                "
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isCondenserCleaningDryOverdue"
                  v-model="w.isCondenserCleaningDry"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isCondenserCleaningDryOverdue">
                  <span class="badge rounded-pill bg-light text-dark">Kondenzator suho</span>
                </label>
                &nbsp;
                <span
                  class="badge rounded-pill"
                  :class="{
                    'bg-warning': w.isCondenserCleaningDryOverdue,
                    'bg-success': !w.isCondenserCleaningDryOverdue,
                  }"
                >
                  {{ w.lastCondenserCleaning === "0001-01-01" ? "Preveri pri vodji" : w.lastCondenserCleaning }}
                </span>
              </div>

              <div
                class="form-check"
                v-show="w.hasCO2Sensor && (w.isCO2SensorOverdue || w.isCO2Sensor || isCo2Check || !isXCheck)"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isCO2Sensorc"
                  v-model="w.isCO2Sensor"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isCO2Sensorc"
                  ><span class="badge rounded-pill bg-info">Senzor CO2</span></label
                >
                &nbsp;
                <span class="badge rounded-pill bg-warning" v-show="w.isCO2SensorOverdue">
                  {{ w.lastCO2Sensor === "0001-01-01" ? "Preveri pri vodji" : w.lastCO2Sensor }}
                </span>
              </div>

              <div
                class="form-check"
                v-show="
                  w.hasThermometerCalibration &&
                  (w.isThermometerCalibrationOverdue ||
                    w.isThermometerCalibration ||
                    isThermometerCalibration ||
                    !isXCheck)
                "
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isThermometerCalibrationibrationc"
                  v-model="w.isThermometerCalibrationibration"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isThermometerCalibrationibrationc">
                  <span class="badge rounded-pill bg-secondary">Umerjanje termometra</span>
                </label>
                &nbsp;
                <span
                  class="badge rounded-pill"
                  :class="{
                    'bg-warning': w.isThermometerCalibrationOverdue,
                    'bg-success': !w.isThermometerCalibrationOverdue,
                  }"
                >
                  {{
                    w.lastThermometerCalibration === "0001-01-01" ? "Preveri pri vodji" : w.lastThermometerCalibration
                  }}
                </span>
                <button
                  class="btn btn-sm btn-outline-secondary ms-2"
                  v-show="w.isRelated && serviceOrderId"
                  @click="
                    $window.open(
                      $router.resolve({
                        name: 'CalibrationReport',
                        params: { workOrderId: serviceOrderId, deviceId: w.id },
                      }).href,
                      '_blank',
                    )
                  "
                >
                  Uredi
                </button>
              </div>
              <div
                class="form-check"
                v-show="w.hasSystemCheck && (w.isSystemCheckOverdue || w.isSystemCheck || isSystemCheck || !isXCheck)"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isSystemCheckc"
                  v-model="w.isSystemCheck"
                  @change="markRelated(w, $event.target.checked)"
                />
                <label class="form-check-label" for="isSystemCheckc">
                  <span class="badge rounded-pill bg-dark">Pregled sistema</span>
                </label>
                &nbsp;
                <span class="badge rounded-pill bg-warning" v-show="w.isSystemCheckOverdue">
                  {{ w.lastSystemCheck === "0001-01-01" ? "Preveri pri vodji" : w.lastSystemCheck }}
                </span>
                <button
                  class="btn btn-sm btn-outline-secondary ms-2"
                  v-show="w.isRelated && serviceOrderId"
                  @click="
                    $window.open(
                      $router.resolve({ name: 'Checklist', params: { workOrderId: serviceOrderId, deviceId: w.id } })
                        .href,
                      '_blank',
                    )
                  "
                >
                  Uredi kontrolni seznam
                </button>
              </div>
            </div>
            <span v-else>
              <span class="badge rounded-pill bg-success me-2" v-show="w.isLeakageTestOverdue">Tesnost</span>
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isServiceOverdue">Servis</span>
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isCondenserCleaningOverdue"
                >Čiščenje kondenzatorja (mokro)</span
              >
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isCondenserCleaningDryOverdue"
                >Čiščenje kondenzatorja (suho)</span
              >
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isCO2SensorOverdue">Senzor CO2</span>
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isSystemCheckOverdue">Pregled sistema</span>
              <span class="badge rounded-pill bg-primary me-2" v-show="w.isThermometerCalibrationOverdue"
                >Umerjanje termometra</span
              >
            </span>
          </td>
          <td @click="selectDevice(w.id)">{{ w.deviceNumber }}</td>
          <td @click="selectDevice(w.id)" v-if="showFacility">{{ w.facilityName }}</td>
          <td @click="selectDevice(w.id)" v-if="showSupplier">
            {{ w.supplier }}<span class="badge rounded-pill bg-danger" v-show="w.isWarranty">Garancija</span>
          </td>

          <td v-show="editDates">
            <span v-show="w.hasLeakageTest"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastLeakageTest"
            /></span>
          </td>
          <td v-show="editDates">
            <span v-show="w.hasService"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastService"
            /></span>
          </td>
          <td v-show="editDates">
            <span v-show="w.hasCondenserCleaningWet || w.hasCondenserCleaningDry"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastCondenserCleaning"
            /></span>
          </td>
          <td v-show="editDates">
            <span v-show="w.hasCO2Sensor"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastCO2Sensor"
            /></span>
          </td>
          <td v-show="editDates">
            <span v-show="w.hasThermometerCalibration"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastThermometerCalibration"
            /></span>
          </td>
          <td v-show="editDates">
            <span v-show="w.hasSystemCheck"
              ><input type="date" class="form-control form-control-sm" v-model="w.lastSystemCheck"
            /></span>
          </td>
          <td v-if="showSelect">
            <input
              type="checkbox"
              v-model="w.isRelated"
              :disabled="
                w.isLeakageTest ||
                w.isServiceTest ||
                w.isCondenserCleaning ||
                w.isCondenserCleaningDry ||
                w.isCO2Sensor ||
                w.isThermometerCalibrationibration ||
                w.isSystemCheck
              "
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { EMPTY_GUID } from "../utils/constants"
import { useEnums } from "../composition-api/useEnums"

defineOptions({ name: "DeviceList" })

const props = defineProps({
  serviceOrderId: { type: String, required: false }, // for opening calibration report
  devices: { type: Array, required: true },
  showSelect: { type: Boolean, default: false },
  showService: { type: Boolean, default: false },
  showFacility: { type: Boolean, default: true },
  showSupplier: { type: Boolean, default: true },
  editDates: { type: Boolean, default: false },
  isLeakageCheck: { type: Boolean, default: false },
  isService: { type: Boolean, default: false },
  isCondenserCleaning: { type: Boolean, default: false },
  isCondenserCleaningDry: { type: Boolean, default: false },
  isThermometerCalibration: { type: Boolean, default: false },
  isSystemCheck: { type: Boolean, default: false },
  isCo2Check: { type: Boolean, default: false },
  showType: { type: Boolean, default: false },
  enableDepth: { type: Boolean, default: false },
})

const router = VueRouter.useRouter()
const { loadEnumsAsync, deviceTypes } = useEnums()
const selectDevice = (deviceId, openInNewWindow = false) => {
  let routeData = router.resolve({ name: "DeviceEdit", params: { deviceId } })
  if (openInNewWindow) {
    window.open(routeData.href, "_blank")
  } else {
    router.push(routeData)
  }
}

// ticking one of the per-service checkboxes marks the device as related to the order
const markRelated = (device, checked) => {
  if (checked) device.isRelated = true
}

const ordered = computed(() => {
  let result = props.devices.slice().sort((a, b) => {
    const A = (a.label || "").toLowerCase()
    const B = (b.label || "").toLowerCase()
    if (A < B) return -1
    if (A > B) return 1
    return 0
  })

  // If any service filter prop is set, only include devices that have
  // at least one of the requested services. If none are set, include all.
  if (isXCheck.value) {
    result = result.filter((device) => {
      return (
        (props.isLeakageCheck && device.hasLeakageTest) ||
        (props.isService && device.hasService) ||
        (props.isCondenserCleaning && device.hasCondenserCleaningWet) ||
        (props.isCondenserCleaningDry && device.hasCondenserCleaningDry) ||
        (props.isThermometerCalibration && device.hasThermometerCalibration) ||
        (props.isSystemCheck && device.hasSystemCheck) ||
        (props.isCo2Check && device.hasCO2Sensor)
      )
    })
    return result // no ordering
  }

  if (props.enableDepth === false) {
    // Add metadata to original objects
    result.forEach((device) => {
      device._isChild = false
      device._level = 0
    })
    return result
  } else {
    const organized = []
    const processed = new Set()
    // First pass - collect parents
    result.forEach((device) => {
      if (!device.sourceDeviceID || device.sourceDeviceID === EMPTY_GUID) {
        device._isChild = false
        device._level = 0
        organized.push(device)
        processed.add(device.id)
      }
    })
    // Second pass - add children after their parents
    const finalOrganized = []
    organized.forEach((parent) => {
      finalOrganized.push(parent)
      result.forEach((device) => {
        if (
          device.sourceDeviceID &&
          device.sourceDeviceID !== EMPTY_GUID &&
          device.sourceDeviceID === parent.id &&
          !processed.has(device.id)
        ) {
          device._isChild = true
          device._level = 1
          finalOrganized.push(device)
          processed.add(device.id)
        }
      })
    })
    // Third pass - add any remaining orphaned devices
    result.forEach((device) => {
      if (!processed.has(device.id)) {
        device._isChild = true
        device._level = 1
        finalOrganized.push(device)
      }
    })
    return finalOrganized
  }
})

const isXCheck = computed(() => {
  return (
    props.isLeakageCheck ||
    props.isService ||
    props.isCondenserCleaning ||
    props.isCondenserCleaningDry ||
    props.isThermometerCalibration ||
    props.isSystemCheck ||
    props.isCo2Check
  )
})

onMounted(async () => {
  await loadEnumsAsync()
})
</script>
